module.exports = __webpack_public_path__ + "img/icon_radio_on.75749ee7.svg";